import { createFileRoute } from '@tanstack/react-router';
import AccountSettings from '@Views/Settings/AccountSettings';

export const Route = createFileRoute('/settings/_layout/')({
    component: AccountSettings,
});
